import { number, object, SchemaOf } from 'yup';

import { MUST_BE_INTEGER, REQUIRED_FIELD } from '@/config/text.const';

export type Fields = {
  interval: number | '';
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  interval: number()
    .min(2)
    .max(10)
    .integer(MUST_BE_INTEGER)
    .required(REQUIRED_FIELD)
});
